import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/bell': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M439.4 362.3C420.1 341.5 383.9 310.3 383.9 208 383.9 130.3 329.4 68.1 256 52.8V32C256 14.3 241.7 0 224 0S192 14.3 192 32V52.8C118.6 68.1 64.1 130.3 64.1 208 64.1 310.3 27.9 341.5 8.6 362.3 2.6 368.7-0.1 376.4 0 384 0.1 400.4 13 416 32.1 416H415.9C435 416 447.9 400.4 448 384 448.1 376.4 445.4 368.7 439.4 362.3zM67.5 368C88.8 340 112 293.7 112.1 208.6 112.1 208.4 112 208.2 112 208 112 146.1 162.1 96 224 96S336 146.1 336 208C336 208.2 335.9 208.4 335.9 208.6 336.1 293.7 359.3 340 380.5 368H67.5zM224 512C259.3 512 288 483.4 288 448H160C160 483.4 188.7 512 224 512z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/bell.js
// module id = h3gw
// module chunks = 144